import { actorQueries } from "@-/dev.improve.haniverse.database.schemas.actor.query";
import { useActorTableChangeVersion } from "@-/dev.improve.haniverse.lib.database.change.actor";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";

export function useGetFavoritedSlideKeysQueryKey() {
  const favoritedSlidesQueryOptions = actorQueries(
    import.meta.location,
  ).userSlide.findMany.useQueryOptions({});
  const withTableChangeVersion = useActorTableChangeVersion("userSlide", {});

  return () =>
    withTableChangeVersion(["favoritedSlideKeys", { favoritedSlidesQueryOptions }] as const);
}

export const [useFavoritedSlideKeysQueryOptions, favoritedSlideKeysQueryFn] = createUseQueryOptions(
  useGetFavoritedSlideKeysQueryKey,
  async ({ client, queryKey: [_, { favoritedSlidesQueryOptions }] }) => {
    const rows = await client.fetchQuery(favoritedSlidesQueryOptions);
    return rows
      .filter((row): row is typeof row & { favoritedAt: string } => row.favoritedAt !== null)
      .sort((a, b) => b.favoritedAt.localeCompare(a.favoritedAt))
      .map((row) => row.key);
  },
);
